import { ReactComponent as Icon24Vk } from '../assets/Icon24Vk.svg';
import { ReactComponent as Icon36Vk } from '../assets/Icon36Vk.svg';
import { ReactComponent as Icon24Telegram } from '../assets/Icon24Telegram.svg';
import { ReactComponent as Icon36Telegram } from '../assets/Icon36Telegram.svg';

export const SOCIALS = [
  {
    type: 'vk',
    url: 'https://vk.com/vkdating',
    icons: {
      24: Icon24Vk,
      36: Icon36Vk,
    },
  },
  {
    type: 'tg',
    url: 'https://t.me/vk_dating',
    icons: {
      24: Icon24Telegram,
      36: Icon36Telegram,
    },
  },
] as const;
